export class ExternalApiNotAvailableError {
  constructor(
    public readonly message: string,
    public readonly innerError: string,
  ) {}
}
